//@author: devin

import { ChangeDetectionStrategy, Component, Input, OnInit, TemplateRef, ViewEncapsulation } from "@angular/core";
import { jSith } from "../../util/jquery-replacement";
import { DropDownItem } from "../../pojo/DropDownItem";
import { S25DropdownPaginatedComponent } from "./s25.dropdown.paginated.component";
import { TypeManagerDecorator } from "../../main/type.map.service";

@TypeManagerDecorator("s25-dropdown-item")
@Component({
    selector: "s25-dropdown-item",
    template: `
        @if (init && !item.isGroup) {
            <ng-container>
                @if (!item.items) {
                    <!-- regular item -->
                    <div
                        class="ngDropdownItem ngParentSelect"
                        [class.ngDropdownHighlighted]="item.isSelected"
                        [class.ngBottomBlackBorder]="item.lastStaticItem"
                        [attr.id]="parent.optionId(item)"
                        role="option"
                        tabindex="-1"
                        [attr.aria-selected]="parent.optionAriaSelected(item)"
                        (click)="parent.select(item, $event)"
                    >
                        <ng-container
                            *ngTemplateOutlet="
                                this.choice;
                                context: {
                                    item: this.item,
                                    $transcludeCtrl: this.parent,
                                    $transcludeSource: this.parent.source,
                                }
                            "
                        ></ng-container>
                    </div>
                } @else {
                    <!-- list of nested items (item.items) -->
                    <div class="ngDropdownItem" [class.ngDropdownHighlighted]="item.isSelected">
                        <div
                            [attr.id]="parent.optionId(item)"
                            role="option"
                            [attr.aria-selected]="parent.optionAriaSelected(item)"
                            (click)="parent.select(item, $event)"
                            class="c-dropdownPaginated-parent"
                            [class.c-dropdownPaginated-parent--isExpanded]="!item.isCollapsed"
                            tabindex="-1"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    arrayChoice;
                                    context: {
                                        item: this.item,
                                        $transcludeCtrl: this,
                                        $transcludeSource: this.parent.source,
                                    }
                                "
                            ></ng-container>
                            <span class="visuallyHidden">{{ item.isCollapsed ? "Collapsed" : "Expanded" }}</span>
                        </div>
                        <ul
                            class="c-dropdownPaginated"
                            [class.c-dropdownPaginated--isExpanded]="!item.isCollapsed"
                            role="group"
                            [attr.aria-labelledby]="parent.optionId(item)"
                        >
                            @for (nestedItem of item.items; track $index) {
                                <li role="presentation" [class.ui-select-choices-row]="!nestedItem.items">
                                    <s25-dropdown-item
                                        [item]="nestedItem"
                                        [parent]="parent"
                                        [choice]="choice"
                                        [arrayChoice]="arrayChoice"
                                    ></s25-dropdown-item>
                                </li>
                            }
                        </ul>
                    </div>
                }
            </ng-container>
        }
    `,
    styles: `
        :host {
            display: block;
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25DropdownItemComponent implements OnInit {
    @Input() item: DropDownItem;
    @Input() parent: S25DropdownPaginatedComponent;
    @Input() choice: TemplateRef<any>;
    @Input() arrayChoice?: TemplateRef<any>;

    init: boolean;

    forEachItem(parentItem: any, callback: Function) {
        if (parentItem && parentItem.nestedItems) {
            jSith.forEach(parentItem.nestedItems, (idx: number, nestedItem: any) => {
                callback(parentItem, nestedItem, idx);
                this.forEachItem(nestedItem, callback);
            });
        }
    }

    toggleCollapse(event?: Event) {
        event?.stopPropagation?.();
        this.item.isCollapsed = !this.item.isCollapsed;
    }

    ngOnInit() {
        if (this.item) {
            this.forEachItem(this.item, (parentItem: any, nestedItem: any, idx: number) => {
                nestedItem.dropDownUUID = parentItem.dropDownUUID + "_" + idx;
            });

            this.item.isCollapsed = true;
            this.item.toggleCollapse = () => this.toggleCollapse();
            this.init = true;
        }
    }
}
